(function () {
    // Wait for element
    function waitForElement(selector, trigger) {
      var interval = setInterval(function () {
        if (
          document &&
          document.querySelector(selector) &&
          document.querySelectorAll(selector).length > 0
        ) {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }
  
    // Activate color
    function activateCurrentColor(block) {
      if (block) {
        document.querySelectorAll(".color-opt.active").forEach((el) => {
          el.classList.remove("active");
        });
  
        var parentContainer = block.closest(".color-opt");
        if (parentContainer) {
          parentContainer.classList.add("active");
        }
      }
    }
  
    // On color change
    var colorBlocks = document.querySelectorAll(".color-container .color-opt");
    if (colorBlocks.length > 0) {
      colorBlocks.forEach((block) => {
        block.addEventListener("click", () => {
          var colorElm = block.querySelector(".color-block");
          var colorId = colorElm.dataset.id;
  
          if (colorId) {
            activateCurrentColor(colorElm);
  
            var colorVariant = document.querySelector(
              `.single-variant [data-color="${colorId}"], .single-variant [data-color="${colorId.toLowerCase()}"], .block-variant-picker  .label-holder [data-color="${colorId}"], .block-variant-picker  .label-holder [data-color="${colorId.toLowerCase()}"]`
            );
            if (colorVariant) {
              colorVariant.focus({ preventScroll: true });
              colorVariant.click();
            }
          }
        });
      });
    }
  
    // Disable focus scroll
    var variantOptions = document.querySelectorAll(
      ".block-variant-picker .label-holder label"
    );
    if (variantOptions.length > 0) {
      variantOptions.forEach((option) => {
        option.focus({ preventScroll: true });
  
        // Click on variant options
        option.addEventListener("click", function () {
          var colorId = option.dataset.value;
          if (colorId) {
            var block = document.querySelector(
              '.color-block[data-id="' + colorId + '"]'
            );
            block && activateCurrentColor(block);
          }
        });
      });
    }
  
    // Click on guide button
    document
      .querySelector(".product-highlight .product-info .guide_btn")
      ?.addEventListener("click", function () {
        document.querySelector(".product-info")?.classList.add("show-chart");
      });
  
    // Click on option title svg
    document
      .querySelector(".product-info .size-chart-box > svg")
      ?.addEventListener("click", function () {
        document.querySelector(".product-info").classList.remove("show-chart");
      });
  
    // Change swiper thumbnail slider position for desktop version
    if (window.innerWidth > 1024) {
      waitForElement(
        ".product-gallery .product-gallery-thumbs .swiper.swiper-initialized",
        verticalSwiperThumbnails
      );
    } else {
      waitForElement(
        ".product-gallery .product-gallery-thumbs .swiper.swiper-initialized",
        gallerySwiperThumbnailsMobile
      );
    }
  
    document.addEventListener("click", function (e) {
      var productInfo = document.querySelector(".product-info");
      if (
        !e.target.closest(".size_chart") &&
        productInfo &&
        !e.target.closest(".guide_btn")
      ) {
        productInfo.classList.remove("show-chart");
      }
    });
  
    // Vertical thumbnail
    function verticalSwiperThumbnails() {
      var thumbSwiper = document.querySelector(
        ".product-gallery .product-gallery-thumbs .swiper.swiper-initialized"
      );
      console.log("variablce thumbnails");
      if (thumbSwiper) {
        thumbSwiper.classList.remove("swiper-horizontal");
        thumbSwiper.classList.add("swiper-vertical");
        Object.assign(thumbSwiper.swiper.params, {
          direction: "vertical",
          slidesPerView: 5,
          slideToClickedSlide: true,
        });
        thumbSwiper.swiper.update();
      }
    }
  
    // Mobile thumbnail
    function gallerySwiperThumbnailsMobile() {
      var thumbSwiper = document.querySelector(
        ".product-gallery .product-gallery-thumbs .swiper.swiper-initialized"
      );
      if (thumbSwiper) {
        thumbSwiper.swiper.params.slidesPerView = 5;
        thumbSwiper.swiper.update();
      }
    }
  
    // Click on floating act button
    document
      .querySelector(
        ".floating-add-to-cart-content .klaviyo-button-wrap .submit-button"
      )
      ?.addEventListener("click", function (e) {
        document
          .querySelector(
            ".product-info .block-buy-buttons .block-buy-buttons__submit"
          )
          ?.click();
      });
  })();
  